import BootstrapNavbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";
import { Text } from "../../utils/Language";
import { Button } from "react-bootstrap";
import { Form, Col, Row } from "react-bootstrap";
import { useState } from "react";

function ActionDetailToolbar(props) {


  return (
    <>
      <BootstrapNavbar
        collapseOnSelect
        bg="light"
        variant="light"
      >
        <BootstrapNavbar.Collapse id="responsive-navbar-nav">
          <Nav className="mx-2">
            <Button onClick={props.onLeftToggle}>
              <i class="fa fa-picture-o"></i>
            </Button>
          </Nav>
          <Nav className="mx-2">
            <Button onClick={props.onDownloadTreatmentPlan}><i className="fa fa-download"></i></Button>
          </Nav>
          <Nav className="mx-2">
            <Button onClick={props.onShareSimulation}><i className="fa fa-paper-plane"></i></Button>
          </Nav>

          <Form className="col-6 mx-5 me-auto">
      <Form.Group as={Row} controlId="formPlaintextEmail">
        <Form.Label column sm="2">
        Patient Name:
        </Form.Label>
        <Col sm="10">
          <Form.Control plaintext readOnly defaultValue={props.patientName} />
        </Col>
      </Form.Group>
      </Form>
          <Nav >
            <Button onClick={props.onRightToggle}><i className="fa fa-comments"></i></Button>
          </Nav>

        </BootstrapNavbar.Collapse>
      </BootstrapNavbar>


    </>
  );
}

export default ActionDetailToolbar;
